export default "__VITE_ASSET__ClTmhqPQ__"